import axios from 'axios';
import { Cita, Paciente } from '../types';

// URL base para el servidor backend
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// URL forzada para producción en Render
const isProduction = window.location.hostname.includes('onrender.com');
const RENDER_API_URL = 'https://fisiofine.onrender.com/api';

// Usar URL forzada en producción
const FINAL_API_URL = isProduction ? RENDER_API_URL : API_URL;

/**
 * Crea una intención de pago de Stripe para el pago de la cita
 */
export const crearSesionPago = async (
  cita: Omit<Cita, 'id' | 'estado' | 'pagado' | 'sesionStripeId'>,
  paciente: Paciente
): Promise<{ clientSecret: string, citaId: string } | null> => {
  try {
    console.log(`Creando intención de pago en: ${FINAL_API_URL}/pagos/crear-sesion`);
    const response = await axios.post(`${FINAL_API_URL}/pagos/crear-sesion`, {
      cita,
      paciente
    });
    
    console.log('Respuesta al crear intención de pago:', response.data);
    
    if (response.data && response.data.exito) {
      return {
        clientSecret: response.data.clientSecret,
        citaId: response.data.citaId
      };
    } else if (response.data && response.data.clientSecret) {
      return {
        clientSecret: response.data.clientSecret,
        citaId: response.data.citaId || ''
      };
    } else {
      console.error('Formato de respuesta inesperado para intención de pago:', response.data);
      return null;
    }
  } catch (error) {
    console.error('Error al crear la intención de pago:', error);
    return null;
  }
};

/**
 * Verifica el estado de un pago
 */
export const verificarEstadoPago = async (
  paymentIntentId: string
): Promise<{ success: boolean, citaId?: string } | null> => {
  try {
    console.log(`Verificando estado de pago para intención: ${paymentIntentId}`);
    const response = await axios.get(`${FINAL_API_URL}/pagos/verificar/${paymentIntentId}`);
    
    console.log('Respuesta al verificar pago:', response.data);
    
    if (response.data) {
      if (response.data.exito !== undefined) {
        return {
          success: response.data.exito,
          citaId: response.data.citaId
        };
      } else if (response.data.success !== undefined) {
        return response.data;
      } else {
        return {
          success: false,
          citaId: undefined
        };
      }
    } else {
      console.error('Formato de respuesta inesperado para verificación de pago:', response.data);
      return null;
    }
  } catch (error) {
    console.error('Error al verificar el estado del pago:', error);
    return null;
  }
}; 